// Keep capture snapshots embedded under the complete query identity. Record
// partition/sequence alone is not globally unique; adjacent nanosecond instants
// and independent refresh anchors must never normalize into the same object.
export const auditCapture = {
  AuditCaptureBundle: { keyFields: false as const },
  AuditCaptureBundleList: { keyFields: false as const },
  AuditCaptureBundleTransactionList: { keyFields: false as const },
  AuditCaptureTransaction: { keyFields: false as const },
  AuditCaptureTransactionGroup: { keyFields: false as const },
  AuditCaptureTransactionSummary: { keyFields: false as const },
  AuditCaptureRecord: { keyFields: false as const },
}
